module.exports = __webpack_public_path__ + "assets/img/gouwuche.4d31f6f2.png";